; (function () {

    addEventListener("DOMContentLoaded", (event) => {
        // theme.liquidで渡されたasset_urlを取得
        const asset_url = window.indexCampaign ?  window.indexCampaign.asset_url : '';
        const campaignList = [
            // 2BUY 10%OFFキャンペーン 8/4 11:00 ～ 8/31 17:00
            {
                'slideshow': 'Slideshow_campaign1', // MVのセクション名 Slideshow_campaign1 または Slideshow_campaign2 を指定
                'start_date': '2026-08-04T11:00:00',
                'end_date':   '2026-08-31T17:00:00',
                'show_sale': true, //falseでセクション「SALE セール品から選ぶ」を非表示にする
                'campaign_sale': false, //falseでセクション「CAMPAIGN」を非表示にする
            },
        ]

        //通常 MVスライダー
        const slideshow = document.querySelector('.shopify-section--slideshow');

        //キャンペーン用 MVスライダー
        const slideshowCampaign1 = document.querySelector('.shopify-section--slideshow_campaign1');
        const slideshowCampaign2 = document.querySelector('.shopify-section--slideshow_campaign2');

        //SALE セール品から選ぶ
        const featuredCollectionsSale = document.querySelector('.js-featured-collections-sale');

        //CAMPAIGN
        const featuredCollectionsCampaign = document.querySelector('.js-featured-collections-campaign');

        //時限設定
        let nowDateTime = new Date();
        const searchParams = new URLSearchParams(window.location.search);
        const testDateParam = searchParams.get('testdate'); // 日時文字列形式 YYYY-MM-DDTHH:mm:ss

        if (testDateParam) {
            nowDateTime = new Date(testDateParam);
        }

        //期間中のキャンペーンデータを抽出
        const campaignFilter = campaignList.filter((cp) => {
            //掲載期間外の場合、次のループへ
            const startDateTime = cp.start_date ? new Date(cp.start_date) : null;
            const endDateTime = cp.end_date ? new Date(cp.end_date) : null;
            if (startDateTime && !(startDateTime <= nowDateTime)) return false;
            if (endDateTime && !(nowDateTime < endDateTime)) return false;

            return cp;
        });

        // 複数は想定しないので、複数ある場合は末尾のみ反映
        // const campaignData = campaignFilter.length ? campaignFilter[campaignFilter.length - 1] : null;
        const campaignData = campaignFilter?.[campaignFilter.length - 1];

        //キャンペーン期間中
        if (campaignData) {

            if (campaignData.slideshow === 'Slideshow_campaign1') {
                if (slideshowCampaign1){
                    slideshowCampaign1.style.opacity = '1';
                    slideshowCampaign1.style.display = 'block';
                }
                if (slideshowCampaign2) slideshowCampaign2.style.display = 'none';
            }

            if (campaignData.slideshow === 'Slideshow_campaign2') {
                if (slideshowCampaign2){
                    slideshowCampaign2.style.opacity = '1';
                    slideshowCampaign2.style.display = 'block';
                }
                if (slideshowCampaign1) slideshowCampaign1.style.display = 'none';
            }

            if (slideshow) {
                slideshow.style.display = 'none';
            }

            if (campaignData.show_sale === false) {
                //SALE セール品から選ぶ を非表示
                if (featuredCollectionsSale) {
                    featuredCollectionsSale.closest('.shopify-section.shopify-section--bordered').style.display = 'none';
                }
            }

            if (campaignData.campaign_sale === false) {
                //CAMPAIGNを非表示
                if (featuredCollectionsCampaign) {
                    featuredCollectionsCampaign.closest('.shopify-section.shopify-section--bordered').style.display = 'none';
                }
            }

        //キャンペーン期間外
        } else {
            if (slideshowCampaign1) {
                slideshowCampaign1.style.display = 'none';
            }

            if (slideshowCampaign2) {
                slideshowCampaign2.style.display = 'none';
            }

            if (slideshow) {
                slideshow.style.opacity = '1';
            }

            //SALE セール品から選ぶ を非表示
            if (featuredCollectionsSale) {
                featuredCollectionsSale.closest('.shopify-section.shopify-section--bordered').style.display = 'none';
            }

            //CAMPAIGN を非表示
            if (featuredCollectionsCampaign) {
                featuredCollectionsCampaign.closest('.shopify-section.shopify-section--bordered').style.display = 'none';
            }
        }

    });
}());